<h1 mat-dialog-title>Prácticas afectadas</h1>
<div mat-dialog-content>
    <table class="table-content margin-top-medium">
        <tr>
            <th>Práctica</th>
            <th> <mat-checkbox [(ngModel)]="allSelected" (change)="checkSelectAllChange($event)"></mat-checkbox></th>
        </tr>

        <tr *ngFor="let procedure of procedures">
            <td style="width: 450px;">{{ getName(procedure) }}</td>
            <td>
                <mat-checkbox [(ngModel)]="procedure.ChangeBillingState"></mat-checkbox>
            </td>
        </tr>
    </table>

</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" (click)="save()">Aceptar</button>
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
</div>
